var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import { Button } from '@material-ui/core';
const useStyles = makeStyles(theme => ({
    noMarginButton: {
        marginLeft: "-10px"
    },
    noArrowText: {
        marginRight: "19.5px"
    }
}));
export default function SortButton(_a) {
    var { collumnProp, collumnName, sortParam, setSortParam, order, setOrder } = _a, props = __rest(_a, ["collumnProp", "collumnName", "sortParam", "setSortParam", "order", "setOrder"]);
    const style = useStyles();
    const handleSortRequest = useCallback((param) => {
        if (sortParam === param) {
            if (order === "ASC") {
                setOrder("DESC");
            }
            else {
                setOrder("ASC");
            }
        }
        else {
            setOrder("ASC");
            setSortParam(param);
        }
    }, [sortParam, setSortParam, order, setOrder]);
    return React.createElement(Button, Object.assign({ className: style.noMarginButton, onClick: () => handleSortRequest(collumnProp) }, props),
        collumnName,
        sortParam === collumnProp && order === "DESC" && React.createElement(ArrowUpwardIcon, null),
        sortParam === collumnProp && order === "ASC" && React.createElement(ArrowDownwardIcon, null),
        sortParam !== collumnProp && React.createElement("span", { className: style.noArrowText }));
}
//# sourceMappingURL=index.js.map